import { useNavigate } from 'react-router-dom'
import { useEscapeListener } from 'app/hooks/useEscapeListener'
import { useUserView } from 'app/components/user-view/useUserView'
import { UserViewComponent } from 'app/components/user-view/UserViewComponent'

export const handle = {
  breadcrumb: (matches: any[]) => {
    const isEmpty = (obj: unknown) => !obj || (typeof obj === `object` && Object.keys(obj!).length === 0)
    let matchPathData = matches.find((match) => !isEmpty(match?.data))
    return matchPathData?.data?.user?.name || matchPathData?.params?.userId
  },
}

export default function UserView() {
  const props = useUserView()
  const navigate = useNavigate()
  useEscapeListener(() => navigate(`/settings/users/active`), true)

  return <UserViewComponent {...props} />
}
